























import { defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import BaseIcon from "@/components/BaseIcon";
import BaseInput from "@/components/BaseInput";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "SearchUsers",
  components: { BaseIcon, BaseInput, BaseSpinner },
  props: {
    value: { type: String, required: true },
    hint: { type: String },
    loading: { type: Boolean, required: true },
    label: { type: String, default: $t("") },
    rules: { type: Array as () => string[] },
  },
});
